// Maintenance-mode API client. Two endpoints:
//   GET /api/maintenance        — public read
//   GET/PUT /api/admin/maintenance — admin read/write

import useSWR from 'swr';

export interface MaintenanceState {
  active: boolean;
  reason?: string;
  until?: string;
  set_by?: string;
  updated_at: string;
}

const fetcher = (url: string) => fetch(url).then((r) => r.json());

export function useMaintenance() {
  return useSWR<MaintenanceState>('/api/maintenance', fetcher, {
    refreshInterval: 30_000,
    revalidateOnFocus: true,
  });
}

export async function setMaintenance(input: {
  active: boolean;
  reason?: string;
  until?: string | null;
}): Promise<MaintenanceState> {
  const res = await fetch('/api/admin/maintenance', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`maintenance toggle failed: ${res.status}`);
  return res.json();
}
